import { Component } from '@angular/core';
import { SkipNoteEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Notes') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipnote-form',
    templateUrl: './skipnote.form.component.html'
})
export class SkipNoteFormComponent extends BaseFormComponent {
    public record!: SkipNoteEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

